import classNames from 'classnames';

import { Theme } from '@/utils/types';

import { ButtonVariant } from './button';

interface ICreateButtonCSS {
  theme: Theme;
  disabled?: boolean;
  variant: ButtonVariant;
  classnames?: string;
}

const createButtonCSS = ({
  variant,
  theme,
  disabled,
  classnames,
}: ICreateButtonCSS): string => {
  const isButton = [ButtonVariant.Primary, ButtonVariant.Secondary].includes(variant);

  return classNames(
    /** apply below styles for any option/type/variant */
    'relative appearance-none min-w-max',

    {
      /** if only a button */
      'px-6 py-2 rounded-full text-white font-medium': isButton,

      /** if variant is secondary and NOT disabled */
      'bg-black': !disabled && variant === ButtonVariant.Secondary,

      /** if variant is secondary and disabled */
      'bg-gray': disabled && variant === ButtonVariant.Secondary,

      /** if variant is primary and NOT disabled */
      [`bg-${theme}-primary shadow-sm shadow-${theme}-primary`]:
        !disabled && variant === ButtonVariant.Primary,

      /** if variant is primary and disabled */
      [`bg-${theme}-light shadow-${theme}-light`]:
        disabled && variant === ButtonVariant.Primary,

      /** if disabled */
      'hover:bg-opacity-90': !disabled,
    },

    /** user can pass any class to override any of above classes */
    classnames,
  );
};

export default createButtonCSS;
